
import React, { useState } from 'react';
import { Table, Button, Col, Row, Media, Input } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";





export const SamplesTable = ({ samples = [], onEditSample, handleOpenModalAuthorization, handleCloseModalAuthorization, isModalAuthorization, selected,
    password, setPassword, saveValidate, invalidPasword, messageInvalid

}) => {
    const [showPassword, setShowPassword] = useState(false);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "aceptada":
                return "linear-gradient(135deg, #51bb25, #3d8f1c)";
            case "rechazada":
                return "linear-gradient(135deg, #de3e4d, #b72839)";
            case "condicionada":
                return "linear-gradient(135deg, #efd23f, #c7a91d)";
            case "pendiente":
                return "linear-gradient(135deg, #ff8a3d, #ff5f24)";
            default:
                return "linear-gradient(135deg, #ff8a3d, #ff5f24)";
        }
    };


    const determinationsBody = (rowData) => {
        return (
            <ul
                style={{
                    margin: 0,
                    paddingLeft: "18px"
                }}
            >
                {rowData.list_exams?.map((exam, index) => (
                    <li
                        key={index}
                        style={{
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "8px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.4",
                            color: "#334155",
                            marginBottom: "2px"
                        }}
                    >
                        {exam.name}
                    </li>
                ))}
            </ul>
        );
    };

    const statusBody = (rowData) => {
        return (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "90px",
                    padding: "0 12px",
                    height: "28px",
                    borderRadius: "30px",
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#fff",
                    background: getStatusColor(rowData.status_name),
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    textTransform: "uppercase",
                    letterSpacing: "0.3px",
                }}
            >
                {rowData.status_name ?? "PENDIENTE"}
            </span>
        );
    };

    const actionsBody = (rowData) => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px"
                }}
            >
                <button
                    onClick={() => onEditSample(rowData)}
                    title={rowData.status_name === "ACEPTADA" ? "Ver muestra" : "Editar muestra"}
                    style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#eff6ff",
                        color: "#2563eb",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: "0 3px 10px rgba(37,99,235,.15)",
                        transition: ".25s"
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.background = "#2563eb";
                        e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.background = "#eff6ff";
                        e.currentTarget.style.color = "#2563eb";
                    }}
                >
                    <i className={`fa ${rowData.status_name === "ACEPTADA" ? "fa-eye" : "fa-edit"}`} />
                </button>

                {rowData.status_name === "ACEPTADA" && (
                    <button
                        onClick={() => handleOpenModalAuthorization(rowData)}
                        title="Desbloquear muestra"
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "10px",
                            border: "none",
                            background: "#fef2f2",
                            color: "#dc2626",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0 3px 10px rgba(220,38,38,.15)",
                            transition: ".25s"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.background = "#dc2626";
                            e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.background = "#fef2f2";
                            e.currentTarget.style.color = "#dc2626";
                        }}
                    >
                        <i className="fa fa-lock" />
                    </button>
                )}
            </div>
        );
    };


    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "14px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "14px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };

    const sampleBody = (rowData) => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    paddingTop: "6px"
                }}
            >
                <span
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px 10px",
                        borderRadius: "6px",
                        background: "#eff6ff",
                        color: "#1d4ed8",
                        fontSize: "12px",
                        fontWeight: 700
                    }}
                >
                    {rowData.name_sample}
                </span>
            </div>
        );
    };

    const typeSampleBody = (rowData) => {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}
            >
                <div
                    style={{
                        width: "38px",
                        height: "38px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "12px",
                        background: "#ff7912",
                        color: "#fff",
                        flexShrink: 0
                    }}
                >
                    <i
                        className="fa fa-flask"
                        style={{
                            fontSize: "16px"
                        }}
                    />
                </div>

                <span
                    style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: "#1e3a8a"
                    }}
                >
                    {rowData.type_sample}
                </span>
            </div>
        );
    };


    return (
        <>
            <div style={{ padding: "20px" }} className='table-wrapper-mic-quoter pt-4'>
                <DataTable
                    value={samples}
                    paginator
                    rows={10}
                    stripedRows
                    responsiveLayout="scroll"
                    emptyMessage="No se encontraron muestras."
                    className="p-datatable-sm"
                >
                    <Column
                        field="code"
                        header="Código de muestra"
                        sortable
                        headerStyle={headerStyle}
                        style={centerStyle}
                    />

                    <Column
                        header="Tipo de muestra"
                        body={typeSampleBody}
                        sortable
                        headerStyle={headerStyle}
                    />

                    <Column
                        header="Muestra"
                        body={sampleBody}
                        sortable
                        headerStyle={headerStyle}
                        style={centerStyle}
                    />

                    <Column
                        header="Determinaciones"
                        body={determinationsBody}
                        headerStyle={headerStyle}
                        style={centerStyle}
                    />

                    <Column
                        header="Estado"
                        body={statusBody}
                        headerStyle={headerStyle}
                        style={centerStyle}
                    />

                    <Column
                        header="Acciones"
                        body={actionsBody}
                        headerStyle={headerStyle}
                        style={centerStyle}
                    />
                </DataTable>

            </div >









            <Dialog
                header={
                    <div className="mic-dialog-header">
                        <div className="mic-dialog-header__content">

                            <div className="mic-dialog-icon">
                                <i className="pi pi-lock"></i>

                            </div>

                            <div>
                                <div className="mic-dialog-title">
                                    {"Autorizar edición de muestra"}
                                </div>


                            </div>

                        </div>
                    </div>
                }
                className={`mic-dialog mic-dialog mic-blue mic-medium`}
                //header={"Autorizar captura"}
                visible={isModalAuthorization}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                onHide={handleCloseModalAuthorization}
                // className="pt-0 custom-dialog-img"
                footer={selected != null && selected.status_name === "ACEPTADA" &&
                    <Col sm="12">
                        <button
                            onClick={() => saveValidate(selected.id_mic_detail_sample)}
                            style={{
                                display: "inline-block",
                                fontWeight: "400",
                                color: "#ffffffff",
                                textAlign: "center",
                                backgroundColor: "#f97316 ",
                                borderColor: "#f97316",
                                borderRadius: " 0.25rem",
                                fontSize: "1rem",
                                lineHeight: " 1.5",
                                transition: "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                height: "30px",
                                width: "120px"
                            }} >
                            Autorizar
                        </button>
                    </Col>
                }
            >
                <Col sm="12">
                    {
                        selected !== null &&
                        <div className='pt-3'>
                            <h6>Esta seguro editar la siguiente muestra: {selected.code ?? "---"} </h6> <br />
                            <Media>
                                <br /> <br />
                                <Media
                                    style={{ paddingTop: "5px" }}
                                    className="img-100 img-fluid m-r-20 rounded-circle"
                                    src={require("../../../assets/images/blog/password.svg")}
                                    alt=""
                                />
                                <Media body>
                                    <Row>
                                        <Col sm="1">
                                        </Col>
                                        <Col sm="7" className="p-0">
                                            <span className="d-block mb-2">
                                                <i className="icofont icofont-key"></i>
                                                <span className="px-2">Acceso de autorización</span>
                                            </span>

                                            <div style={{ position: "relative", width: "100%" }}>
                                                <InputText
                                                    type={showPassword ? "text" : "password"}
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    className="w-100"
                                                    style={{
                                                        paddingRight: "40px",
                                                        height: "38px",
                                                        borderRadius: "8px"
                                                    }}
                                                />

                                                <i
                                                    className={showPassword ? "pi pi-eye-slash" : "pi pi-eye"}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "12px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#6c757d",
                                                        fontSize: "1rem",
                                                        zIndex: 10
                                                    }}
                                                ></i>
                                            </div>
                                        </Col>
                                    </Row>
                                </Media>
                            </Media>
                            <Col sm="12" className='pt-4 p-l-0 p-r-0'  >
                                {invalidPasword && (
                                    <Message severity="error" text={messageInvalid} c />
                                )}
                            </Col>
                        </div>
                    }
                </Col>
            </Dialog>

        </>


    );
};
